/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import humanparser from 'humanparser';
import Session from 'entities/Session';
import ToastActions from 'actions/ToastActions';
import PromptActions from 'actions/PromptActions';
import LinkSmsDevicePage from 'user/components/LinkSmsDevicePage.jsx';
import { PromptNames } from 'constants/PromptConstants';
import GroupActions from 'groups/actions/GroupActions';
import UserActions from 'user/UserActions';
import errorLogger from 'utils/errorLogger';

type Props = {
  location: Object,
  params: Object,
};

type State = {
  groupCode: string,
  address: string,
  token: string,
  name: ?string,
};

class JoinConfirmSmsDevicePage extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      groupCode: props.params.groupCode,
      address: props.location.query.address,
      token: props.location.query.token,
      name: props.location.query.name,
    };
  }

  onDone = (device: { token: string }) => {
    const onUserUpdateSuccess = user => {
      GroupActions.subscribeToGroupWithCode(this.state.groupCode).then(
        () => {
          this.context.router.push(
            user.getRole() ? '/classes?origin=subscribed' : '/join/role_picker'
          );
        },
        () => {
          this.context.router.push(`/join/role_picker/${this.state.groupCode}`);
        }
      );
    };

    const onUserUpdateFailure = () => {
      ToastActions.showErrorToast('An error occured');
      this.context.router.push(`/join/${this.state.groupCode}`);
    };

    const onSessionExchanged = () => {
      // bypass the setup sms device setup step.
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SMS_DEVICE);
      const human = humanparser.parseName(this.state.name);

      UserActions.update({
        prefix: human.salutation,
        last_name: human.lastName,
        first_name: human.firstName,
      }).then(onUserUpdateSuccess, onUserUpdateFailure);
    };

    Session.createWithToken(device.token)
      .then(onSessionExchanged)
      .catch(errorLogger('JoinConfirmSmsDevicePage onDone failed'));
  };

  render() {
    return <LinkSmsDevicePage {...this.state} onDone={this.onDone} instantResend />;
  }
}

export default JoinConfirmSmsDevicePage;
